var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEtapas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 150,
    height: 150,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Etapas",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    className: "cls-2",
    d: "M63.331,63.328V7.7A7.708,7.708,0,0,1,71.039-.006h71.252A7.708,7.708,0,0,1,150,7.7V142.29A7.708,7.708,0,0,1,142.292,150H7.708A7.709,7.709,0,0,1,0,142.29V71.036a7.708,7.708,0,0,1,7.708-7.708Zm7.5,79.17h71.461a.208.208,0,0,0,.208-.208V7.7a.208.208,0,0,0-.208-.208H71.039a.209.209,0,0,0-.208.208V142.5Zm-7.5-71.67H7.708a.208.208,0,0,0-.208.208V142.29a.208.208,0,0,0,.208.208H63.331Z",
    transform: "translate(0 0.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    className: "cls-2",
    d: "M284.141,315.568a7.709,7.709,0,0,0-7.708-7.708H260.6a7.708,7.708,0,0,0-7.708,7.708v27.711a3.75,3.75,0,0,0,3.75,3.75h23.75a3.75,3.75,0,0,0,3.75-3.75Zm-7.5,0a.208.208,0,0,0-.208-.208H260.6a.208.208,0,0,0-.209.208v23.961h16.25Z",
    transform: "translate(-161.85 -197.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    className: "cls-2",
    d: "M331.2,51.687a7.708,7.708,0,0,0-7.708-7.708h-7.916a7.709,7.709,0,0,0-7.708,7.708v7.918a7.709,7.709,0,0,0,7.709,7.708h7.916a7.708,7.708,0,0,0,7.708-7.708Zm-7.5,0a.208.208,0,0,0-.209-.208h-7.916a.209.209,0,0,0-.208.208v7.918a.208.208,0,0,0,.208.208h7.916a.208.208,0,0,0,.209-.208V51.687Z",
    transform: "translate(-197.033 -28.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    className: "cls-2",
    d: "M243.234,51.687a7.708,7.708,0,0,0-7.709-7.708H227.61a7.708,7.708,0,0,0-7.709,7.708v7.918a7.708,7.708,0,0,0,7.709,7.708h7.917a7.708,7.708,0,0,0,7.708-7.708Zm-7.5,0a.209.209,0,0,0-.208-.208h-7.917a.208.208,0,0,0-.208.208v7.918a.208.208,0,0,0,.208.208h7.916a.208.208,0,0,0,.208-.208V51.687Z",
    transform: "translate(-140.737 -28.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    className: "cls-2",
    d: "M243.234,139.65a7.709,7.709,0,0,0-7.709-7.709H227.61a7.709,7.709,0,0,0-7.709,7.709v7.916a7.708,7.708,0,0,0,7.709,7.708h7.917a7.708,7.708,0,0,0,7.708-7.709Zm-7.5,0v7.916a.209.209,0,0,1-.208.209H227.61a.208.208,0,0,1-.208-.209V139.65a.208.208,0,0,1,.208-.208h7.917a.208.208,0,0,1,.208.208Z",
    transform: "translate(-140.737 -84.442)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    className: "cls-2",
    d: "M331.2,139.65a7.708,7.708,0,0,0-7.708-7.709h-7.917a7.708,7.708,0,0,0-7.708,7.709v7.916a7.708,7.708,0,0,0,7.709,7.708h7.916a7.708,7.708,0,0,0,7.708-7.709Zm-7.5,0v7.916a.209.209,0,0,1-.208.209h-7.917a.209.209,0,0,1-.208-.209V139.65a.209.209,0,0,1,.208-.208h7.917a.208.208,0,0,1,.208.208Z",
    transform: "translate(-197.033 -84.442)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    className: "cls-2",
    d: "M243.234,227.615a7.708,7.708,0,0,0-7.709-7.708H227.61a7.708,7.708,0,0,0-7.709,7.708v7.916a7.708,7.708,0,0,0,7.709,7.708h7.917a7.708,7.708,0,0,0,7.708-7.708Zm-7.5,0a.209.209,0,0,0-.208-.208h-7.917a.208.208,0,0,0-.208.208v7.916a.208.208,0,0,0,.208.208h7.916a.208.208,0,0,0,.208-.208Z",
    transform: "translate(-140.737 -140.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    className: "cls-2",
    d: "M331.2,227.613a7.708,7.708,0,0,0-7.708-7.709h-7.917a7.708,7.708,0,0,0-7.708,7.709v7.916a7.709,7.709,0,0,0,7.709,7.709h7.916a7.708,7.708,0,0,0,7.708-7.709Zm-7.5,0v7.916a.208.208,0,0,1-.208.208h-7.917a.208.208,0,0,1-.208-.208v-7.917a.209.209,0,0,1,.208-.208h7.917a.209.209,0,0,1,.208.208Z",
    transform: "translate(-197.033 -140.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    className: "cls-2",
    d: "M83.143,227.613a7.708,7.708,0,0,0-7.708-7.709H51.684a7.709,7.709,0,0,0-7.708,7.709v7.916a7.709,7.709,0,0,0,7.709,7.709h23.75a7.708,7.708,0,0,0,7.708-7.709Zm-7.5,0v7.916a.208.208,0,0,1-.208.208H51.684a.208.208,0,0,1-.208-.208v-7.917a.208.208,0,0,1,.208-.208h23.75a.209.209,0,0,1,.208.208Z",
    transform: "translate(-28.145 -140.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    className: "cls-2",
    d: "M83.144,315.575a7.708,7.708,0,0,0-7.708-7.708H51.684a7.708,7.708,0,0,0-7.708,7.708v7.916a7.708,7.708,0,0,0,7.708,7.708H75.435a7.708,7.708,0,0,0,7.708-7.709Zm-7.5,0v7.916a.209.209,0,0,1-.208.209H51.684a.209.209,0,0,1-.208-.209v-7.916a.208.208,0,0,1,.208-.208H75.435a.208.208,0,0,1,.208.208Z",
    transform: "translate(-28.145 -197.035)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtapas);
export default __webpack_public_path__ + "static/media/Etapas.fd43f25fec7d4acfee210e7af1f69211.svg";
export { ForwardRef as ReactComponent };